import React from 'react'
import { useField } from 'formik'

import { DateFieldProps, WithDateFieldProps } from './interface'

export function withDateField(Component: React.FC<DateFieldProps>) {
  function WithDateField({ name, onChange, ...props }: WithDateFieldProps) {
    const [field, meta, { setValue, setTouched }] = useField(name)

    function handleChange(val: Date | null) {
      setValue(val)
      if (onChange) {
        onChange()
      }
    }

    function handleBlur() {
      if (!meta.touched) {
        setTouched(true)
      }
    }

    const componentProps = {
      ...props,
      ...field,
      value: field.value,
      selected: field.value,
      error: meta.touched && meta.error,
      onChange: handleChange,
      onBlur: handleBlur,
    }

    return <Component {...componentProps} />
  }

  WithDateField.defaultProps = {
    showErrorMessage: false,
    disabled: false,
  }

  return WithDateField
}
